import ActionType from '../action.types'

const initial = {
  isLoading: false,
  byKey: {},
}

function setNested(state, customerid, key, slot, payload) {
  const keyState = state.byKey[key] || { clinics: {} }
  const clinicState = keyState.clinics[customerid] || {}
  return {
    ...state,
    byKey: {
      ...state.byKey,
      [key]: {
        ...keyState,
        clinics: {
          ...keyState.clinics,
          [customerid]: { ...clinicState, [slot]: payload },
        },
      },
    },
  }
}

export default function settings(state = initial, action) {
  switch (action.type) {
    case ActionType.SETTINGS_INPROGRESS:
      return { ...state, isLoading: !!action.isLoading }

    case ActionType.SETTINGS_CLINIC_LOADED:
      return setNested(state, action.customerid, action.key, 'override', action.data)

    case ActionType.SETTINGS_RESOLVED_LOADED:
      return setNested(state, action.customerid, action.key, 'resolved', action.value)

    case ActionType.LOGOUT:
      return initial

    default:
      return state
  }
}
